'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import 'angular-socket-io';

import 'ngStorage';
// import 'ngCsv';

import ngCsv from 'ng-csv';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';


import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import homeowner from './homeowner/homeowner.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import '../components/services';
import application from './application/application.component';
import telFilter from './filters/tel/tel.filter.js';

import './configFile.js';

import './app.scss';


const debug = require('debug')('fifi:app');


angular.module('parkingFormApp', [ngCookies, ngResource, ngSanitize, ngCsv, 'ngStorage', 'btford.socket-io', uiRouter,
  uiBootstrap, _Auth, account, admin, navbar, footer, main, homeowner, constants, socket, application, util,
  require('angular-stripe'), require('angular-credit-cards'), require('angular-ui-mask'), require('angular-loading-bar'),
  require('angular-scroll'), 'parkingformApp.services', telFilter, require('angular-moment')])
  .config(routeConfig)
  .config(['EnvironmentConfig', 'stripeProvider', function(EnvironmentConfig, stripeProvider) {
    stripeProvider.setPublishableKey(EnvironmentConfig.stripeKey);
    debug(EnvironmentConfig.environment);
  }])
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  })
  .run(function($rootScope, $state) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(evt, to, params) {
      if(to.redirectTo) {
        evt.preventDefault();
        $state.go(to.redirectTo, params);
      }
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['parkingFormApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js